module.exports = __webpack_public_path__ + "img/pr-13.e1572b6a.png";